import { useMemo, useCallback } from 'react';
import { BudgetRecipientEnum } from '../types';
import { BudgetStatusEnum } from '../../../../enums/budgetStatus';

interface IUseFactoryJourneyParams {
  isEditMode: boolean;
  profile?: BudgetRecipientEnum;
  recipient?: string;
  status?: BudgetStatusEnum;
  orcamentoStatus?: BudgetStatusEnum;
}

export const useFactoryJourney = (params: IUseFactoryJourneyParams) => {
  const { isEditMode, profile, recipient, status, orcamentoStatus } = params;

  const isFactory = profile === BudgetRecipientEnum.TOWER;

  const getRecipientOptions = useCallback(
    (allOptions: Array<{ id: string; label: string }>) => {
      if (isEditMode && recipient === BudgetRecipientEnum.MANAGER) {
        return allOptions.filter((option) => option.id === BudgetRecipientEnum.MANAGER);
      }

      return allOptions.filter((option) => option.id !== profile);
    },
    [profile, isEditMode, recipient],
  );

  const getButtonLabel = useCallback(
    (
      isEditMode: boolean,
      counterProposal: boolean,
      counterProposalValue?: number,
    ): string => {
      if (
        isEditMode &&
        counterProposal &&
        counterProposalValue !== undefined &&
        counterProposalValue > 0
      ) {
        return 'Aceitar alterações e enviar';
      }

      return isEditMode ? 'Enviar alterações' : 'Enviar orçamento';
    },
    [],
  );

  const shouldShowRejectionSection = useMemo(() => {
    if (
      orcamentoStatus !== BudgetStatusEnum.PENDING &&
      status !== BudgetStatusEnum.PENDING
    ) {
      if (
        isEditMode &&
        (orcamentoStatus === BudgetStatusEnum.REJECTED ||
          status === BudgetStatusEnum.REJECTED) &&
        recipient === BudgetRecipientEnum.MANAGER
      ) {
        return false;
      }
      return true;
    }
    return false;
  }, [orcamentoStatus, status, isEditMode, recipient]);

  return {
    isFactory,
    getRecipientOptions,
    getButtonLabel,
    shouldShowRejectionSection,
  };
};

